export enum TextTypes {
  Default,
  Navigation,
  ButtonGreen,
  ButtonTransparent,
  ButtonBlack,
  SidebarNew,
  Sidebar,
}
